import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const BOUGHT_IN_STORE_SET_SORT_ORDER = 'waitrose/favourites/BOUGHT_IN_STORE_SET_SORT_ORDER';

export const BOUGHT_IN_STORE_CATEGORY_FILTER_IMPRESSION =
  'waitrose/favourites/BOUGHT_IN_STORE_CATEGORY_FILTER_IMPRESSION';
export const BOUGHT_IN_STORE_OFFER_FILTER_IMPRESSION =
  'waitrose/favourites/BOUGHT_IN_STORE_OFFER_FILTER_IMPRESSION';
export const BOUGHT_IN_STORE_SORT_IMPRESSION =
  'waitrose/favourites/BOUGHT_IN_STORE_SORT_IMPRESSION';

export const GET_BOUGHT_IN_STORE_PRODUCTS = apiPromiseTypes('bought-in-store-products', 'get');
